import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AgGridModule } from 'ag-grid-angular';

import { DataGridComponent } from './data-grid.component';
import { LinkRendererComponent } from '@shared/components/cell-renderers/link-renderer/link-renderer.component';
import { CrudOperationsRendererComponent } from '../cell-renderers/crud-operations-renderer/crud-operations-renderer.component';

@NgModule({
  imports: [
    CommonModule,
    AgGridModule.withComponents(
      [
        LinkRendererComponent,
        CrudOperationsRendererComponent
      ]
    )
  ],
  declarations: [DataGridComponent],
  exports: [DataGridComponent]
})
export class DataGridModule { }
